import container from '../container';
import { Grid } from '@mui/material';

export default function ControllersFactory({ configs, formIndex, defaultState }) {
  if (!Array.isArray(configs)) throw new Error('Controllers configs should be an array!');
  return (
    <Grid container aria-label="form-controller-grid-container" spacing={3}>
      {configs.map((config, index) => {
        const defaultValue = ensureDefaultValue(config, defaultState ?? {});
        if (config.type === 'grid-row-break') return <div key={config.name ?? index}>&nbsp;</div>;

        return <ControllerFactory {...config} defaultValue={defaultValue} key={config.name ?? index} formIndex={formIndex} />;
      })}
    </Grid>
  );
}

function ControllerFactory({ responsive, ...props }) {
  const Controller = container.getController(props.type);
  let breakpoints = responsive ?? { xs: 12 };

  if (!Controller)
    return (
      <>
        No Component of {props.type} registered for {props.name}
      </>
    );

  return (
    <Grid {...breakpoints} item aria-label="controller-grid-item">
      <Controller {...props} />
    </Grid>
  );
}

function ensureDefaultValue(controlConfigs, defaultValues) {
  const { name } = controlConfigs;
  if (name in defaultValues) {
    return defaultValues[name];
  }
  if ('defaultValue' in controlConfigs && controlConfigs.defaultValue !== undefined) return controlConfigs.defaultValue;
}
